import React from "react";
import { Link } from "react-router-dom";
import { FileText, TrendingUp, Users, CalendarCheck } from "lucide-react";
import SEO from '../../components/SEO';





export default function ContentMarketing() {
  return (
      <>
    <SEO title="Content Marketing" />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#8cc540] py-16 text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Content Marketing</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Grow your brand organically with strategic, valuahow ble, and engaging content tailored to your audience.
        </p>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-12 space-y-12">
        {/* Introduction */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-4">What is Content Marketing?</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            Content Marketing is a long-term digital strategy focused on creating and distributing valuable, relevant, and consistent content to attract and engage a specific audience. Instead of pitching your products or services, you’re providing truly useful content that helps your audience solve their problems and builds trust in your brand.
          </p>
        </section>

        {/* Services Offered */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-6">Our Content Marketing Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <ServiceCard icon={<FileText size={30} />} title="Content Strategy">
              Develop a solid roadmap tailored to your business goals and audience. We create data-driven plans aligned with SEO and customer journey stages.
            </ServiceCard>
            <ServiceCard icon={<TrendingUp size={30} />} title="Blog & SEO Articles">
              Boost organic traffic with high-quality blog posts optimized for search engines, written to educate, engage, and convert your audience.
            </ServiceCard>
            <ServiceCard icon={<Users size={30} />} title="Social Media Content">
              We design engaging content calendars and visuals for platforms like Facebook, Instagram, LinkedIn, and more — aligned with your brand voice.
            </ServiceCard>
            <ServiceCard icon={<CalendarCheck size={30} />} title="Email Newsletters">
              Retain and convert customers with personalized, high-converting email content that nurtures leads and drives repeat engagement.
            </ServiceCard>
            <ServiceCard icon={<FileText size={30} />} title="Website Copywriting">
              Your website content is your digital storefront. We write persuasive landing page and homepage copy that resonates and converts.
            </ServiceCard>
            <ServiceCard icon={<TrendingUp size={30} />} title="Infographics & Visual Content">
              Simplify complex ideas into beautiful, shareable visual assets that engage and educate your audience across platforms.
            </ServiceCard>
          </div>
        </section>

        {/* Benefits */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-4">Why Content Marketing Matters</h2>
          <ul className="list-disc list-inside text-gray-700 text-lg space-y-2">
            <li><strong>Builds Trust & Authority:</strong> Consistent content positions your brand as a thought leader in your industry.</li>
            <li><strong>Improves SEO:</strong> Quality content increases visibility on search engines and helps your website rank higher.</li>
            <li><strong>Generates Quality Leads:</strong> Valuable content attracts an audience that’s genuinely interested in your product or service.</li>
            <li><strong>Supports Social Engagement:</strong> Content gives people a reason to follow, share, and interact with your brand online.</li>
            <li><strong>Cost Effective:</strong> Content marketing delivers compounding ROI over time compared to paid ads.</li>
          </ul>
        </section>

        {/* Quote */}
        <section>
          <div className="bg-[#f7fdf3] border-l-4 border-[#8cc540] p-6 rounded-md shadow-sm">
            <p className="text-[#0a3c6d] font-medium text-lg italic">
              “Content is the atomic particle of all digital marketing.”
            </p>
            <p className="text-sm text-gray-500 mt-2">– Rebecca Lieb</p>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center pt-8">
          <h3 className="text-xl font-semibold text-[#0a3c6d] mb-4">Ready to Boost Your Brand with Powerful Content?</h3>
          <Link
            to="/contact-us"
            className="inline-block bg-[#8cc540] hover:bg-[#7aaa38] text-white font-semibold px-6 py-3 rounded-md transition"
          >
            Let’s Discuss Your Content Plan
          </Link>
        </section>
      </div>
    </div>
    </>
  );
}

// Sub-component for services
const ServiceCard = ({ icon, title, children }) => (
  <div className="border-t-4 border-[#8cc540] bg-white rounded-lg shadow-md p-6 space-y-4 hover:shadow-lg transition">
    <div className="flex items-center space-x-3 text-[#0a3c6d]">
      {icon}
      <h3 className="text-lg font-bold">{title}</h3>
    </div>
    <p className="text-gray-600 text-sm">{children}</p>
  </div>
);
